<form [formGroup]="form">
    <mat-form-field>
        <input
            matInput
            type="text"
            placeholder="Company name or chamber of commerce number"
            i18n-placeholder="@@configurator.company.placeholder-company-picker"
            aria-label="Number"
            [matAutocomplete]="companySearchAutocomplete"
            formControlName="company"
        />
        <mat-autocomplete
            #companySearchAutocomplete="matAutocomplete"
            (optionSelected)="optionSelected($event.option.value)"
            [displayWith]="displayFn"
        >
            <mat-option *ngFor="let company of companySearchResult" [value]="company">
                <div class="company">
                    <div class="name">
                        {{ company.name }}<br />
                        <div class="chamberOfCommerceNumber">{{ company.chamberOfCommerceNr }}</div>
                    </div>
                    <div class="address">
                        <ng-container *ngIf="company.address">
                            {{ company.address.street }} {{ company.address.houseNr }}{{ company.address.houseNrSuffix
                            }}<br />
                            {{ company.address.zipCode }}, {{ company.address.city }}
                        </ng-container>
                    </div>
                </div>
            </mat-option>
        </mat-autocomplete>
    </mat-form-field>
    <mat-progress-bar *ngIf="displayProgressBar" mode="indeterminate"></mat-progress-bar>
</form>
